const providerRoutes = {
    sign_in: "/sign-in",
    sign_up: "/sign-up",
    otp_verify: "/verify-otp",
    otp_resend: "/resend-otp",
    sign_out: "/sign-out",
    refresh_token: "/refresh-token",
    get_services: "/services",
    o_auth: "/o-auth",
    profile: "/profile",
    register: "/register",
    notifications: "/notifications",
    count: "/count",
    forgot_password: "/forgot-password",
    confirm_password: "/confirm-password",
    forgot_otp_verify: "/verify-forgot-password-otp",
    reset_password: "/reset-password",
    schedules: "/schedules",
    booking_request: "/booking-requests",
    bookings: "/bookings",
    payments: "/payments",
    chats: "/chats",
    dashboard: "/dashboard",
    monthly_revenue: "/revenue",
    report: "/report",
};
export default providerRoutes;
